/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.sessions.di

import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import studio.oddpods.cauce.feature.sessions.CreateRecurringScheduleViewModel
import studio.oddpods.cauce.feature.sessions.EditRecurringScheduleViewModel
import studio.oddpods.cauce.feature.sessions.EditSessionViewModel
import studio.oddpods.cauce.feature.sessions.LogSessionViewModel
import studio.oddpods.cauce.feature.sessions.SessionDetailViewModel
import kotlin.time.Clock

val SessionsModule = module {
    viewModelOf(::LogSessionViewModel)
    viewModel { CreateRecurringScheduleViewModel(Clock.System, get(), get(), get(), get()) }
    viewModel { params ->
        SessionDetailViewModel(
            sessionId = params.get(),
            sessionRepository = get(),
            currencyFormatter = get(),
            dateFormatter = get(),
        )
    }
    viewModel { params ->
        EditRecurringScheduleViewModel(
            scheduleId = params.get(),
            patientName = params.get(),
            recurringScheduleRepository = get(),
            currencyFormatter = get(),
            dateFormatter = get(),
        )
    }
    viewModel { params ->
        EditSessionViewModel(
            sessionId = params.get(),
            sessionRepository = get(),
            patientRepository = get(),
            currencyFormatter = get(),
            dateFormatter = get(),
        )
    }
}
